var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('FieldValueSelect',{attrs:{"value":_vm.browseFilterValue,"name-options":_vm.browseFieldOptions,"pivots":_vm.pivots,"messages":_vm.messages,"is-explain":"","position":"row","data-test":"browse-list-filter"},on:{"input":_vm.setBrowseFilter}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }